<template>
  	<q-layout :view="getView">
		<q-page-container>
			<router-view :style="themeStyles" />
		</q-page-container>

		<etraining-footer />
  	</q-layout>
</template>

<script>
import Footer from 'components/not_authenticated/Footer'
import { colors } from 'quasar'
import { mapGetters } from 'vuex'

export default {
	components: {
		'etraining-footer': Footer
	},

	computed: {
        ...mapGetters({
			login_colors: 'params/login_colors',
			login_use_background: 'params/login_use_background',
			login_full_background: 'params/login_full_background',
            params_loaded: 'params/params_loaded',
		}),

		themeStyles () {
			if (this.login_use_background) {
				return {
					backgroundPosition: 'center',
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					backgroundImage: `url(${this.login_full_background})`
				}
			}
			else return ''
		},

		getView() {
			if (this.$q.platform.is.mobile) return 'hHh Lpr lFf'
			else return 'hHh Lpr fff'
		},
	},

	watch: {
		params_loaded: function() {
            colors.setBrand('primary', this.login_colors.primary)
            colors.setBrand('secondary', this.login_colors.secondary)
            colors.setBrand('tertiary', this.login_colors.tertiary)
        }
	},

	created() {
		if (this.login_colors) {
			colors.setBrand('primary', this.login_colors.primary)
			colors.setBrand('secondary', this.login_colors.secondary)
			colors.setBrand('tertiary', this.login_colors.tertiary)
		}


	}
}
</script>

<style>
</style>
